<template>
  <div
    :class="classes"
    :style="styles"
  />
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'cGradient',
  props: {
    direction: {
      type: String,
      default: 'bottom',
      description: '(top / right / bottom / left)',
    },
    opacity: {
      type: Number,
      default: 1,
    },
  },
  setup(props) {
    const styles = computed(() => {
      return {
        'background-image': `linear-gradient(to ${props.direction}, rgba(255, 255, 255, 0), rgb(0, 0, 0))`,
        opacity: props.opacity,
      }
    })

    const classes = computed(() => ['c-gradient'])

    return {
      styles,
      classes,
    }
  },
}
</script>

<style lang="scss" scoped>
.c-gradient {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
